/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12.41 2.04c-.418.21-.731.627-.731 1.045V6.32c0 .104-.104.208-.104.208-4.07 1.357-6.888 3.758-7.619 6.784-.73 2.818.418 5.844 3.027 8.453.313.313.835.313 1.043 0 .313-.313.313-.835 0-1.043-1.252-1.253-1.774-2.714-1.356-4.175.521-1.774 2.296-3.34 4.696-4.07.104 0 .209 0 .209.104V15.4c0 .626.521 1.148 1.148 1.148.313 0 .626-.104.834-.313l6.47-6.47c.314-.313.314-.835 0-1.044l-6.47-6.47c-.208-.21-.626-.313-1.148-.21Z"
})), "0 0 24 24", "Share");